<template>
  <div class="animated fadeIn">
    <div class="col-sm-12 col-md-12">
      <div class="loading" v-if="processando">
        <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
        </div>
      </div>

      <div class="modal fade show " id="modalExportarPontos" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
        data-backdrop="static" v-if="showModalExportarPontos">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Exportar Arquivo de Pontos</h4>
            </div> 
            <div class="modal-body">
              <div class="col-md-12">
                
                <div class="row">
                  <div class="form-group col-md-6">
                    <label>Data Inicial:</label><br>
                    <input-data-picker v-model="exportarPontos.dataInicial" name="data" v-validate="'required'" data-vv-delay="500" :class="{'input pula form-control data': true, 'is-danger': errors.has('data') }" />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Data Final:</label><br>
                    <input-data-picker v-model="exportarPontos.dataFinal" name="data" v-validate="'required'" data-vv-delay="500" :class="{'input pula form-control data': true, 'is-danger': errors.has('data') }" />
                  </div>
                </div>
                
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success" data-dismiss="modal" v-on:click="gerarExportarPontos"><i v-if="botaoProcessando" class="fa fa-spinner fa-spin"></i> Gerar</button>
              <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalExportarPontos = false">Fechar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade show " id="modalAdicioarCredito" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
        data-backdrop="static" v-if="showModalNovaJornada">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Nova Jornada</h4>
            </div> 
            <div class="modal-body">
              <div class="col-md-12">
                 <div class="row">
                  <div class="form-group col-sm-12 col-md-12">
                    <label>Tipo Jornada:</label><br>
                    <select id="modalItemTipoJornada" class="form-control" required="required" v-model="jornada.tipoJornada">
                      <option value="1">Jornada</option>
                      <!-- <option value="2">Diaria</option> -->
                      <option value="3">Falta</option>
                      <option value="4">Folga</option>
                      <option value="5">Folga Semanal</option>
                      <option value="9">Folga I.J.</option>
                      <option value="6">Feriado</option>
                      <option value="7">Atestado</option>
                      <option value="8">Ferias</option>
                      <option value="10">Compensado</option>
                    </select>
                  </div>
                </div>
                <template v-if="jornada.tipoJornada === '1'">
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label>Data Hora Inicial:</label><br>
                      <input-data-hora-picker v-model="jornada.dataHoraInicial" name="data" v-validate="'required'" data-vv-delay="500" :class="{'input pula form-control data': true, 'is-danger': errors.has('data') }" />
                    </div>
                    <div class="form-group col-md-6">
                      <label>Data Hora Final:</label><br>
                      <input-data-hora-picker v-model="jornada.dataHoraFinal" name="data" v-validate="'required'" data-vv-delay="500" :class="{'input pula form-control data': true, 'is-danger': errors.has('data') }" />
                    </div>
                  </div>
                </template>
                <template v-else-if="jornada.tipoJornada === '8'">
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label>Data Inicial:</label><br> 
                      <input-data-picker v-model="jornada.dataHoraInicial" name="data" v-validate="'required'" data-vv-delay="500" :class="{'input pula form-control data': true, 'is-danger': errors.has('data') }" />
                    </div>
                    <div class="form-group col-md-6">
                      <label>Data Final:</label><br>
                      <input-data-picker v-model="jornada.dataHoraFinal" name="data" v-validate="'required'" data-vv-delay="500" :class="{'input pula form-control data': true, 'is-danger': errors.has('data') }" />
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="row">
                    <div class="form-group col-md-12">
                      <label>Data:</label><br>
                      <input-data-picker v-model="jornada.dataHoraInicial" name="data" v-validate="'required'" data-vv-delay="500" :class="{'input pula form-control data': true, 'is-danger': errors.has('data') }" />
                    </div>
                  </div>
                </template>
                
                <div class="row">
                  <div class="form-group col-sm-12 col-md-12">
                    <label>Motorista:</label><br>
                    <input id="motoristaNovaJornadaId" type="hidden" class="form-control" v-model="jornada.motoristaId">
                    <buscar-lista-motorista  id="motoristaNovaJornadaNome" placeholder="Selecione um motorista.." v-model="jornada.motoristaNome" :classes="{ input: 'input pula form-control', wrapper: 'input-wrapper'}" :on-select="setarMotoristaNovaJornada" :on-blur="verificarMotoristaNovaJornada" />
                  </div>
                </div>
                <template v-if="jornada.tipoJornada === '1'">
                  <div class="row">
                    <div class="form-group col-sm-12 col-md-12">
                      <label>Veículo:</label><br>
                      <input id="veiculoNovaJornadaId" type="hidden" class="form-control" v-model="jornada.veiculoId">
                      <buscar-veiculo type="search" id="veiculoNovaJornadaDescricao" placeholder="Selecione um veículo.." v-model="jornada.veiculoDescricao" :classes="{ input: 'input pula form-control', wrapper: 'input-wrapper'}" :on-select="setarVeiculoNovaJornada" :on-blur="verificarVeiculoNovaJornada" />
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success" data-dismiss="modal" v-on:click="gerarNovaJornada"><i v-if="botaoProcessando" class="fa fa-spinner fa-spin"></i> Gerar</button>
              <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalNovaJornada = false">Fechar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade show " id="modalAdicioarCredito" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
        data-backdrop="static" v-if="showModalRelatorioSintetico">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Relatório Sintético</h4>
            </div> 
            <div class="modal-body">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <label>Tipo Relatório:</label><br>
                    <select class="form-control" required="required" v-model="relatorio.tipo">
                      <option value="1">Relatório Sintetico</option>
                      <option value="2">Relatório de Tempo de Alimentção</option>
                      <template v-if="$auth.check('P110')">
                        <option value="3">Relatório Sintetico TESTE</option>
                      </template>
                    </select>  
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <label>Data Inicial:</label><br>
                    <input-data-picker v-model="relatorio.dataInicial" name="data" v-validate="'required'" data-vv-delay="500" :class="{'input pula form-control data': true, 'is-danger': errors.has('data') }" />
                  </div>
                  <div class="col-md-6">
                    <label>Data Final:</label><br>
                    <input-data-picker v-model="relatorio.dataFinal" name="data" v-validate="'required'" data-vv-delay="500" :class="{'input pula form-control data': true, 'is-danger': errors.has('data') }" />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-sm-12 col-md-12">
                    <div class="row">
                      <div class="form-group col-sm-6 col-md-6">
                      <label>Motoristas/Cargo</label><br>
                      <input class="form-control hasclear" type="text" v-model="relatorio.buscas" v-on:keyup.enter="buscarTodosMotoristasRelatorio()" />
                      </div>
                      <div class="form-group col-sm-6 col-md-6">
                        <label>&nbsp;</label><br>
                        <input class="btn btn-success" type="button" v-on:click="buscarTodosMotoristasRelatorio()" value="Buscar">
                        <button type="button" class="btn btn-success" data-dismiss="modal" v-on:click="selecionadoMotoristaTodos"> Selecionar Todos</button>
                        <button type="button" class="btn btn-success" data-dismiss="modal" v-on:click="selecionadoMotoristaLimpar"> Limpar Seleção</button>
                      </div>
                    </div>
                    <div style="max-height: calc(100vh - 444px); overflow-y: auto;">
                    <table id="tabelaMotoristas"
                      class="table table-responsive-sm table-hover table-outline mb-0"
                      width="100%">
                      <thead class="thead-light">
                        <tr>
                          <th></th>
                          <th>Nome</th>
                          <th>Cargo</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="motorista in dadosMotoristas" :class="{ 'selecionado': selecionadoMotorista(motorista) }" @click="selecionarMotoristaItem(motorista)">
                          <td width="40"><input type="hidden" :id="motorista.id" class="id"/>
                            <template v-if="selecionadoMotorista(motorista)">
                              <img src="/static/images/true.png" />
                            </template>
                            <template v-else>
                              <img src="/static/images/false.png" />
                            </template>
                          </td>
                          <td width="50">{{motorista.id}}</td>
                          <td>
                            <strong>{{motorista.nome}}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    </div>
                    <input id="motoristaId" type="hidden" class="form-control" v-model="relatorio.motoristaId">
                    <!-- <buscar-lista-motorista id="motoristaNome" placeholder="Selecione um motorista.." v-model="relatorio.motoristaNome" :classes="{ input: 'input pula form-control', wrapper: 'input-wrapper'}" :on-select="setarMotorista" :on-blur="verificarMotorista" /> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              
              <button type="button" class="btn btn-success" data-dismiss="modal" v-on:click="gerarRelatorioSinteticoMotoristas"><i v-if="botaoProcessando" class="fa fa-spinner fa-spin"></i> Gerar </button>
              <!-- <button type="button" class="btn btn-success" data-dismiss="modal" v-on:click="gerarRelatorioSintetico"><i v-if="botaoProcessando" class="fa fa-spinner fa-spin"></i> Gerar</button> -->
              <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalRelatorioSintetico = false">Fechar</button>
            </div>
          </div>
        </div>
      </div>
      
      <div class="card">
        <div class="card-body">
          <div id="titulo" class="panel panel-default">
            <!-- Default panel contents -->
            <div class="panel-body">
              <div class="row row-margin">
                <div class="col-md-12">
                  <h4>Gestão de Jornadas</h4>
                </div>
              </div>
              <div class="row row-margin">
                <div class="col-md-12">
                  <button type="button" class="btn btn-success" v-on:click="showModalNovaJornada = true"> 
                    <span class="glyphicon glyphicon-plus"></span> Nova Jornada Manual
                  </button>
                  <button type="button" class="btn btn-primary" v-on:click="juntarJornada">
                    <span class="glyphicon glyphicon-plus"></span> Juntar Jornadas
                  </button>
                  <button type="button" class="btn btn-primary" v-on:click="duplicarJornada">
                    <span class="glyphicon glyphicon-plus"></span> Duplicar Jornada
                  </button>
                  <button type="button" class="btn btn-primary" v-on:click="abrirModalRelatorioSintetico"> 
                    <span class="glyphicon glyphicon-plus"></span> Relatório Sintético
                  </button>

                  <button type="button" class="btn btn-danger" v-on:click="deletarMultiplas">
                    <span class="glyphicon glyphicon-plus"></span> Deletar Jornadas
                  </button>

                  <template v-if="$auth.check('P110')">
                    <button type="button" class="btn btn-danger" v-on:click="recalcularJornadas">
                      <span class="glyphicon glyphicon-plus"></span> Recalcular Jornadas
                    </button>
                  </template>

                  <button type="button" class="btn btn-warning" v-on:click="showModalExportarPontos = true">
                    <span class="glyphicon glyphicon-plus"></span> Exportar Arq. Ponto
                  </button>

                  <span id="imprimirLinks"> </span>
                </div>
              </div>
            </div>
          </div>

          <div id="filtros" class="panel panel-default">
            <!-- Default panel contents -->
            <div class="panel-body">
              <div class="row row-margin">
                <div class="col-sm-1 col-md-1">
                  <div class="form-group">
										<label class="label-filtros">Periodo:</label>
										<input-data-picker class="pula data form-control" v-model="filtros.dataInicial" />
									</div>
								</div>
								<div class="col-md-1">
									<div class="form-group">
										<label class="label-filtros">&nbsp;</label>
										<input-data-picker class="pula data form-control" v-model="filtros.dataFinal" />
									</div>
								</div>
								<div class="col-sm-8 col-md-8">
									<div class="form-group has-feedback">
										<label class="label-filtros">Buscar:</label><br>
										<input class="form-control hasclear" type="text" v-model="filtros.buscas" v-on:keyup.enter="buscar()" />
										<span id="limparbusca" class="glyphicon glyphicon-remove-circle"></span>
									</div>
								</div>
								
								<div class="col-sm-1 col-md-1">
									<div class="form-group">
										<label class="label-filtros">Exibir:</label>
										<select class="pula form-control custom" v-model="filtros.status" >
											<option value="todos" selected="selected">Todos</option>
											<option value="aprovadacom">Aprovada com Documento</option>
											<option value="aprovadasem">Aprovada</option>
											<option value="gerado">Gerado pelo Sistema</option>
											<option value="editado">Editado Manual</option>
										</select>
									</div>
								</div>
								<div class="col-md-1">
									<div class="form-group">
										<label class="label-filtros">&nbsp;</label><br>
										<input class="btn btn-success" type="button" v-on:click="buscar()" value="Buscar">
									</div>
								</div>
							</div>
						</div>
					</div>
          <div class="row">
            <div class="col-sm-12 col-md-12">
              <div id="dados-limpo">
                <input id="idsSelecionados" type="hidden"/>
                <table id="tabelaVeiculos"
                class="table table-responsive-sm table-hover table-outline mb-0"
                width="100%">
                <thead class="thead-light">
                  <tr>
                    <th>Cód</th>
                    <th>Período</th>
                    <th>Veículo</th>
                    <th>Motorista</th>
                    <th>Status</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="jornada in dadosTabela" :class="{ 'selecionado': selecionado(jornada) }" @click="selecionarItem(jornada, $event)" v-on:dblclick="editar(jornada.id)">
                    <td width="50">{{jornada.id}}</td>
                    <td width="155">{{jornada.dataHoraInicial}}<br/>{{jornada.dataHoraFinal}}</td>
                    <td>
                      <template v-if="jornada.diaria === true"> 
                        <strong>DIÁRIA</strong>
                      </template>
                      
                       
                      <template v-if="jornada.folga === true"> 
                        <strong>FOLGA</strong>
                      </template>
                       
                      <template v-if="jornada.folgaSemanal === true"> 
                        <strong>FOLGA SEMANAL</strong>
                      </template>
                      
                      <template v-if="jornada.folgaIJ === true"> 
                        <strong>FOLGA I.J.</strong>
                      </template>
                      
                      <template v-if="jornada.falta === true"> 
                        <strong>FALTA</strong>
                      </template>
                      
                      <template v-if="jornada.feriado === true"> 
                        <strong>FERIADO</strong>
                      </template>
                      
                      <template v-if="jornada.atestado === true"> 
                        <strong>ATESTADO</strong>
                      </template>
                      
                      <template v-if="jornada.ferias === true"> 
                        <strong>FÉRIAS</strong>
                      </template>

                      <template v-if="jornada.compensado === true"> 
                        <strong>COMPENSADO</strong>
                      </template>


                      <template v-if="jornada.veiculoDescricao !== null"> 
                        <strong>{{jornada.veiculoDescricao}}</strong>
                      </template> 
                    </td>
                    <td>{{jornada.motoristaNome}}</td>
                    <td>{{jornada.status}}</td>
                    <td width="80">
                      <template v-if="jornada.ajudante1Id !== null">
                        <img v-tooltip="'Gerar Jornada Ajudante 1'" v-on:click="gerarJornadaAjudante(jornada.id, 1)" src="/static/images/motorista.png" />
                      </template>
                      <template v-if="jornada.ajudante2Id !== null">
                        <img v-tooltip="'Gerar Jornada Ajudante 2'" v-on:click="gerarJornadaAjudante(jornada.id, 2)" src="/static/images/motorista.png" />
                      </template>
                      <template v-if="jornada.ajudante3Id !== null">
                        <img v-tooltip="'Gerar Jornada Ajudante 3'" v-on:click="gerarJornadaAjudante(jornada.id, 3)" src="/static/images/motorista.png" />
                      </template>
                    </td>
                    <td width="80">
                      <img v-tooltip="'Imprimir'" v-on:click="imprimir(jornada.id)"  src="/static/images/imprimir.png" />
                      <router-link v-tooltip="'Editar'" :to="{name: 'GestaoJornadasEditar', params: { id: jornada.id }}" class="">
                        <img src="/static/images/editar.png" />
                      </router-link>
                      <img v-tooltip="'Deletar'" v-on:click="deletar(jornada.id)" src="/static/images/deletar.png" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

</template>
<script>
import vuePages from 'vue-pages'
import axios from 'axios'
import Blob from 'blobjs'
export default {
  data () {
    return {
      filtros: {
        dataInicial: (this.$store.state.filtrosGestaoJornada.dataInicial === '' ? this.primeiroDiaMes('') : this.$store.state.filtrosGestaoJornada.dataInicial),
        dataFinal: (this.$store.state.filtrosGestaoJornada.dataFinal === '' ? this.ultimoDiaMes('') : this.$store.state.filtrosGestaoJornada.dataFinal),
        buscas: this.$store.state.filtrosGestaoJornada.buscas,
        status: this.$store.state.filtrosGestaoJornada.status
      },
      jornada: {
        dataInicial: this.primeiroDiaMes(''),
        dataFinal: this.ultimoDiaMes(''),
        motoristaId: '0',
        motoristaNome: '',
        veiculoId: '0',
        veiculoDescricao: '',
        tipoJornada: '1'
      },
      relatorio: {
        tipo: '1',
        dataInicial: this.primeiroDiaMes(''),
        dataFinal: this.ultimoDiaMes(''),
        motoristaId: '0',
        motoristaNome: '',
        buscas: ''
      },
      exportarPontos: {
        dataInicial: this.primeiroDiaMes(''),
        dataFinal: this.ultimoDiaMes('')
      },
      dadosTabela: [],
      selecionadas: [],
      motoristas: [],
      motoristasSelecionados: [],
      dadosMotoristas: [],
      selecionadasMotoristas: [],
      selecionada: '',
      processando: false,
      botaoProcessando: false,
      showModalNovaJornada: false,
      showModalRelatorioSintetico: false,
      showModalExportarPontos: false
    }
  },
  created: function () {
    this.buscar(this.$store.state.filtrosVeiculo.pagina)
  },
  components: {
    vuePages
  },
  mounted: function () {
    $('.pula').keypress(function (e) {
      var tecla = (e.keyCode ? e.keyCode : e.which)
      if (tecla === 13) {
        let campo = $('.pula')
        let indice = campo.index(this)
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus()
        }
        if (campo[indice + 1] != null) {
          let proximo = campo[indice + 1]
          proximo.focus()
        }
        e.preventDefault(e)
        return false
      }
    })
    this.buscar()
    this.buscarTodosMotoristas()
  },
  methods: {
    selecionarItem: function (item, event) {
      this.selecionada = item
      if (event.ctrlKey || event.metaKey) {
        this.selecionadas.push(item)
      } else {
        this.selecionadas = []
        this.selecionadas.push(item)
      }
    },
    selecionado: function (item) {
      for (let i = 0; i < this.selecionadas.length; i++) {
        if (this.selecionadas[i].id === item.id) {
          return true
        }
      }
      return false
    },
    buscarTodosMotoristasRelatorio: function () {
      let self = this
      self.processando = true
      self.botaoProcessando = true
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      }
      var url = '/api/buscarMotoristasAtivos?busca=' + self.relatorio.buscas
      axios.get(url, config)
      .then(function (response) {
        self.dadosMotoristas = response.data.slice()
        self.selecionadasMotoristas = response.data.slice()
        self.processando = false
        self.botaoProcessando = false
      }).catch(function (error) {
        console.log(error)
        self.processando = false
        self.botaoProcessando = false
      })
    },
    selecionarMotoristaItem: function (item, event) {
      this.selecionadaMotorista = item
      if (this.selecionadoMotorista(item)) {
        this.removerMotorista(item)
      } else {
        this.selecionadasMotoristas.push(item)
      }
    },
    selecionadoMotorista: function (item) {
      for (let i = 0; i < this.selecionadasMotoristas.length; i++) {
        if (this.selecionadasMotoristas[i].id === item.id) {
          return true
        }
      }
      return false
    },
    removerMotorista: function (item) {
      for (let i = 0; i < this.selecionadasMotoristas.length; i++) {
        if (this.selecionadasMotoristas[i].id === item.id) {
          console.log('Remove ' + item)
          this.selecionadasMotoristas.splice(i, 1)
        }
      }
    },
    selecionadoMotoristaTodos: function () {
      this.selecionadasMotoristas = this.dadosMotoristas.slice()
    },
    selecionadoMotoristaLimpar: function () {
      this.selecionadasMotoristas = []
    },
    paginacao (d, e) {
      this.pagina = d
      this.buscar(this.pagina)
    },
    buscar: function () {
      var self = this
      this.$store.commit('SET_FILTROS_GESTAO_JORNADA', self.filtros)
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      self.processando = true
      var url = '/api/gestaoJornadas?buscas=' + this.filtros.buscas + '&dataInicial=' + this.filtros.dataInicial + '&dataFinal=' + this.filtros.dataFinal + '&status=' + this.filtros.status
      axios.get(url, config)
      .then(function (response) {
        dadosCadastro = response.data
        self.dadosTabela = dadosCadastro.dados
        self.processando = false
      })
    },
    editar: function (id) {
      this.$router.replace('/gestaoJornada/editar/' + id)
    },
    juntarJornada: function (id) {
      var self = this
      if (self.selecionadas.length !== 2) {
        self.$toastr('error', 'Selecione duas Jornadas para Combinar.', 'Atenção')
        return
      }
      let message = 'Deseja realmente combinar essas Jornadas?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // coming soon: 'soft', 'hard'
        verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
        clicksCount: 3 // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
      }
      this.$dialog.confirm(message, options)
      .then((dialog) => {
        var config = {
          headers: {'Authorization': 'Bearer ' + this.$store.state.token}
        }
        self.processando = true
        var url = '/api/gestaoJornadas/juntarJornada?jornadaUmId=' + self.selecionadas[0].id + '&jornadaDoisId=' + self.selecionadas[1].id
        axios.get(url, config)
        .then(function (response) {
          self.processando = false
          if (response.data === 'OK') {
            self.$toastr('success', 'Jornadas combinadas com sucesso.', 'Atenção')
            self.buscar()
            dialog.close()
          } else {
            self.$toastr('error', 'Erro ao combinar a Jornada', 'Atenção')
            dialog.close()
          }
        })
      })
      .catch(function () {
        console.log('Clicked on cancel')
      })
    },
    abrirModalRelatorioSintetico: function () {
      this.buscarTodosMotoristasRelatorio()
      this.showModalRelatorioSintetico = true
    },
    duplicarJornada: function (id) {
      var self = this
      if (self.selecionadas.length === 0) {
        return
      }
      if (self.selecionadas.length > 1) {
        return
      }
      let message = 'Deseja realmente duplicar essa Jornada?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // coming soon: 'soft', 'hard'
        verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
        clicksCount: 3 // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
      }
      this.$dialog.confirm(message, options)
      .then((dialog) => {
        var config = {
          headers: {'Authorization': 'Bearer ' + this.$store.state.token}
        }
        self.processando = true
        var url = '/api/gestaoJornadas/duplicar?id=' + self.selecionadas[0].id
        axios.get(url, config)
        .then(function (response) {
          self.processando = false
          if (response.data === 'OK') {
            self.$toastr('success', 'Jornada duplicada com sucesso.', 'Atenção')
            self.buscar()
            dialog.close()
          } else {
            self.$toastr('error', 'Erro ao duplicar a Jornada', 'Atenção')
            dialog.close()
          }
        })
      })
      .catch(function () {
        console.log('Clicked on cancel')
      })
    },
    deletarMultiplas: function (id) {
      var self = this
      let message = 'Deseja realmente deletar todas as Jornada listadas?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // coming soon: 'soft', 'hard'
        verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
        clicksCount: 3 // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
      }
      this.$dialog.confirm(message, options)
      .then((dialog) => {
        var config = {
          headers: {'Authorization': 'Bearer ' + this.$store.state.token}
        }
        self.processando = true
        var url = '/api/gestaoJornadas/deletarMultiplas?buscas=' + this.filtros.buscas + '&dataInicial=' + this.filtros.dataInicial + '&dataFinal=' + this.filtros.dataFinal + '&status=' + this.filtros.status
        axios.get(url, config)
        .then(function (response) {
          self.processando = false
          if (response.data === 'OK') {
            self.$toastr('success', 'Jornadas deletadas com sucesso.', 'Atenção')
            self.buscar()
            dialog.close()
          } else {
            self.$toastr('error', 'Erro ao deletar as Jornadas', 'Atenção')
            dialog.close()
          }
        })
      })
      .catch(function () {
        console.log('Clicked on cancel')
      })
    },
    recalcularJornadas: function (id) {
      var self = this
      let message = 'Deseja realmente recalcular todas as Jornada listadas?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // coming soon: 'soft', 'hard'
        verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
        clicksCount: 3 // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
      }
      this.$dialog.confirm(message, options)
      .then((dialog) => {
        var config = {
          headers: {'Authorization': 'Bearer ' + this.$store.state.token}
        }
        self.processando = true
        var url = '/api/gestaoJornadas/recalcularJornadas?buscas=' + this.filtros.buscas + '&dataInicial=' + this.filtros.dataInicial + '&dataFinal=' + this.filtros.dataFinal + '&status=' + this.filtros.status
        axios.get(url, config)
        .then(function (response) {
          self.processando = false
          if (response.data === 'OK') {
            self.$toastr('success', 'Jornadas recalculadas com sucesso.', 'Atenção')
            self.buscar()
            dialog.close()
          } else {
            self.$toastr('error', 'Erro ao recalcular as Jornadas', 'Atenção')
            dialog.close()
          }
        })
      })
      .catch(function () {
        console.log('Clicked on cancel')
      })
    },
    setarMotorista: function (motorista) {
      this.relatorio.motoristaId = motorista.id
      this.relatorio.motoristaNome = motorista.nome
      $(this.$el).find('#motoristaNome').val(motorista.nome)
    },
    verificarMotorista: function () {
      if ($(this.$el).find('#motoristaId').val() === '0') {
        this.relatorio.motoristaId = 0
        this.relatorio.motoristaNome = ''
        $(this.$el).find('#motoristaId').val(0)
        $(this.$el).find('#motoristaNome').val('')
      }
      if ($(this.$el).find('#motoristaNome').val() === '') {
        this.relatorio.motoristaId = 0
        this.relatorio.motoristaNome = ''
        $(this.$el).find('#motoristaId').val(0)
        $(this.$el).find('#motoristaNome').val('')
      }
    },
    setarMotoristaNovaJornada: function (motorista) {
      this.jornada.motoristaId = motorista.id
      this.jornada.motoristaNome = motorista.nome
      $(this.$el).find('#motoristaNovaJornadaNome').val(motorista.nome)
    },
    verificarMotoristaNovaJornada: function () {
      if ($(this.$el).find('#motoristaNovaJornadaId').val() === '0') {
        this.jornada.motoristaId = 0
        this.jornada.motoristaNome = ''
        $(this.$el).find('#motoristaNovaJornadaId').val(0)
        $(this.$el).find('#motoristaNovaJornadaNome').val('')
      }
      if ($(this.$el).find('#motoristaNovaJornadaNome').val() === '') {
        this.jornada.motoristaId = 0
        this.jornada.motoristaNome = ''
        $(this.$el).find('#motoristaNovaJornadaId').val(0)
        $(this.$el).find('#motoristaNovaJornadaNome').val('')
      }
    },
    buscarTodosMotoristas: function () {
      let self = this
      self.processando = true
      self.botaoProcessando = true
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      }
      var url = '/api/buscarMotoristasAtivos?busca='
      axios.get(url, config)
      .then(function (response) {
        self.motoristas = response
        self.processando = false
        self.botaoProcessando = false
      }).catch(function (error) {
        console.log(error)
        self.processando = false
        self.botaoProcessando = false
      })
    },
    setarVeiculoNovaJornada: function (veiculo) {
      this.jornada.veiculoId = veiculo.idVeiculo
      this.jornada.veiculoDescricao = veiculo.descricaoVeiculo
      $(this.$el).find('#veiculoNovaJornadaDescricao').val(veiculo.descricaoVeiculo)
    },
    verificarVeiculoNovaJornada: function () {
      if ($(this.$el).find('#veiculoNovaJornadaId').val() === '0') {
        this.jornada.veiculoId = 0
        this.jornada.veiculoDescricao = ''
        $(this.$el).find('#veiculoNovaJornadaId').val(0)
        $(this.$el).find('#veiculoNovaJornadaDescricao').val('')
      }
      if ($(this.$el).find('#veiculoNovaJornadaDescricao').val() === '') {
        this.jornada.veiculoId = 0
        this.jornada.veiculoDescricao = ''
        $(this.$el).find('#veiculoNovaJornadaId').val(0)
        $(this.$el).find('#veiculoNovaJornadaDescricao').val('')
      }
    },
    imprimir: function (id) {
      // Imprimir
      let self = this
      self.processando = true
      self.botaoProcessando = true
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      }
      var url = '/api/gestaoJornadas/imprimirJornadaAnalitica?id=' + id + '&semMovimento=0'
      axios.get(url, config)
      .then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
        const link = document.createElement('a')
        link.href = url
        // link.setAttribute('filename', 'file.pdf')
        link.setAttribute('target', '_blank')
        document.getElementById('imprimirLinks').appendChild(link)
        link.click()
        self.processando = false
        self.botaoProcessando = false
      }).catch(function (error) {
        console.log(error)
        self.processando = false
        self.botaoProcessando = false
      })
    },
    gerarRelatorioSintetico: function (e) {
      // Imprimir
      let self = this
      self.processando = true
      self.botaoProcessando = true
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      }
      var url = ''
      if (this.relatorio.tipo === 1 || this.relatorio.tipo === '1') {
        url = '/api/gestaoJornadas/imprimirJornadaSinteticaHorario?dataHoraInicio=' + this.relatorio.dataInicial + ' 00:00:00&dataHoraFinal=' + this.relatorio.dataFinal + ' 23:59:59&motoristaId=' + this.relatorio.motoristaId
      } else {
        url = '/api/gestaoJornadas/relatorioTempoAlimentacao?dataHoraInicio=' + this.relatorio.dataInicial + ' 00:00:00&dataHoraFinal=' + this.relatorio.dataFinal + ' 23:59:59&motoristaId=' + this.relatorio.motoristaId
      }
      axios.get(url, config)
      .then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
        const link = document.createElement('a')
        link.href = url
        // link.setAttribute('filename', 'file.pdf')
        link.setAttribute('target', '_blank')
        document.getElementById('imprimirLinks').appendChild(link)
        link.click()
        self.processando = false
        self.botaoProcessando = false
      }).catch(function (error) {
        console.log(error)
        self.processando = false
        self.botaoProcessando = false
      })
    },
    gerarRelatorioSinteticoMotoristas: function () {
      let self = this
      self.processando = true
      self.botaoProcessando = true
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      }
      for (let i = 0; i < self.selecionadasMotoristas.length; i++) {
        var url = ''
        if (this.relatorio.tipo === 1 || this.relatorio.tipo === '1') {
          url = '/api/gestaoJornadas/imprimirJornadaSinteticaHorario?dataHoraInicio=' + this.relatorio.dataInicial + ' 00:00:00&dataHoraFinal=' + this.relatorio.dataFinal + ' 23:59:59&motoristaId=' + self.selecionadasMotoristas[i].id
        } else if (this.relatorio.tipo === 2 || this.relatorio.tipo === '2') {
          url = '/api/gestaoJornadas/relatorioTempoAlimentacao?dataHoraInicio=' + this.relatorio.dataInicial + ' 00:00:00&dataHoraFinal=' + this.relatorio.dataFinal + ' 23:59:59&motoristaId=' + self.selecionadasMotoristas[i].id
        } else if (this.relatorio.tipo === 3 || this.relatorio.tipo === '3') {
          url = '/api/gestaoJornadas/imprimirJornadaSinteticaHorario?teste=1&dataHoraInicio=' + this.relatorio.dataInicial + ' 00:00:00&dataHoraFinal=' + this.relatorio.dataFinal + ' 23:59:59&motoristaId=' + self.selecionadasMotoristas[i].id
        }
        axios.get(url, config)
        .then(function (response) {
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf;name=document.pdf;'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('filename', 'file.pdf')
          if (self.relatorio.tipo === 1 || self.relatorio.tipo === '1') {
            link.setAttribute('download', 'JornadaSintetico_' + self.relatorio.dataInicial.replace('/', '') + '_' + self.relatorio.dataFinal.replace('/', '') + '_' + self.selecionadasMotoristas[i].nome.replace(/\s+/g, ''))
          } else if (self.relatorio.tipo === 3 || self.relatorio.tipo === '3') {
            link.setAttribute('download', 'JornadaSintetico_' + self.relatorio.dataInicial.replace('/', '') + '_' + self.relatorio.dataFinal.replace('/', '') + '_' + self.selecionadasMotoristas[i].nome.replace(/\s+/g, ''))
          } else {
            link.setAttribute('download', 'RelatorioTempoAlimentacao_' + self.relatorio.dataInicial.replace('/', '') + '_' + self.relatorio.dataFinal.replace('/', '') + '_' + self.selecionadasMotoristas[i].nome.replace(/\s+/g, ''))
          }
          link.setAttribute('target', '_blank')
          document.getElementById('imprimirLinks').appendChild(link)
          link.click()
          self.processando = false
          self.botaoProcessando = false
        }).catch(function (error) {
          console.log(error)
          self.processando = false
          self.botaoProcessando = false
        })
      }
    },
    gerarNovaJornada: function (e) {
      // Imprimir
      let self = this
      self.processando = true
      self.botaoProcessando = true
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      }
      var url = '/api/gestaoJornadas/novo?dataHoraInicio=' + this.jornada.dataHoraInicial + '&dataHoraFinal=' + this.jornada.dataHoraFinal + '&veiculoId=' + this.jornada.veiculoId + '&motoristaId=' + this.jornada.motoristaId + '&tipoJornada=' + this.jornada.tipoJornada
      axios.get(url, config)
      .then(function (response) {
        // link.setAttribute('filename', 'file.pdf')
        self.processando = false
        self.botaoProcessando = false
        self.showModalNovaJornada = false
        self.buscar()
      }).catch(function (error) {
        console.log(error)
        self.processando = false
        self.botaoProcessando = false
      })
    },
    gerarJornadaAjudante: function (jornada, ajudante) {
      // Imprimir
      let self = this
      self.processando = true
      self.botaoProcessando = true
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      }
      var url = '/api/gestaoJornadas/gravarJornadaAjudante?jornada=' + jornada + '&ajudante=' + ajudante
      axios.get(url, config)
      .then(function (response) {
        self.processando = false
        self.botaoProcessando = false
        self.buscar()
      }).catch(function (error) {
        console.log(error)
        self.processando = false
        self.botaoProcessando = false
      })
    },
    gerarExportarPontos: function () {
      // Imprimir
      let self = this
      self.processando = true
      self.botaoProcessando = true
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      }
      var url = '/api/gestaoJornadas/exportarPontos?dataInicial=' + self.exportarPontos.dataInicial + '&dataFinal=' + self.exportarPontos.dataFinal
      axios.get(url, config)
      .then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/text'}))
        const link = document.createElement('a')
        link.href = url
        // link.setAttribute('filename', 'file.pdf')
        link.setAttribute('download', 'ExportacaoPonto_' + self.exportarPontos.dataInicial.replace('/', '') + '_' + self.exportarPontos.dataFinal.replace('/', '') + '.txt')
        link.setAttribute('target', '_blank')
        document.getElementById('imprimirLinks').appendChild(link)
        link.click()
        self.processando = false
        self.botaoProcessando = false
        self.buscar()
      }).catch(function (error) {
        console.log(error)
        self.processando = false
        self.botaoProcessando = false
      })
    },
    deletar: function (id) {
      let self = this
      let message = 'Deseja realmente deletar essa Jornada?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // coming soon: 'soft', 'hard'
        verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
        clicksCount: 3 // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
      }
      this.$dialog.confirm(message, options)
      .then((dialog) => {
        setTimeout(() => {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$store.state.token
            }
          }
          self.loading = true
          var url = '/api/gestaoJornadas/deletar?id=' + id
          axios.get(url, config)
          .then(function (response) {
            console.log(response)
            if (response.data === 'OK') {
              self.$toastr('success', 'Jornada deletada com sucesso.', 'Atenção')
              self.buscar()
              dialog.close()
            } else {
              self.$toastr('error', 'Essa Jornada está em USO e não pode ser deletado.', 'Atenção')
              dialog.close()
            }
          })
          .catch(function (error) {
            console.log(error)
          })
        }, 2500)
      })
      .catch(function () {
        console.log('Clicked on cancel')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/jornadas/GestaoJornadasLista.vue